export default __webpack_public_path__ + "static/media/UpdateExample.8b328b8a.csv";